import React from 'react'
import { Select2, ItemRendererProps, ItemListPredicate } from '@blueprintjs/select'
import { MenuItem } from '@blueprintjs/core'
import { Button, HighlightedText } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import fuzzy from 'fuzzaldrin-plus'

export type timeOption = { value: number; display: string }

export const timeList = Array(168 / 12 + 11)
  .fill(0)
  .map((e, i) => {
    // i + 1 => 1 - 12; if greater than 12 increment by multiple of 12
    return i + 1 > 12 ? (i + 2 - 12) * 12 : i + 1
  })

const createOptions: (min: number) => timeOption[] = (min) =>
  timeList
    .map((value) => ({
      value,
      display: `${value} hr`,
    }))
    .filter((t) => t.value >= min)

export default function TimeSelect({
  onChange,
  value,
  buttonProps,
  limit,
  disableSearch,
  min = 1,
}: {
  onChange: (value: timeOption) => void
  value: number
  buttonProps?: IUIButtonProps
  limit?: number
  disableSearch?: boolean
  min?: number
}) {
  if (!value) return null

  const TimeSelect = Select2<timeOption>
  let options = createOptions(min)

  if (limit) {
    options = options.filter((i) => i.value <= limit)
  }

  return (
    <TimeSelect
      popoverProps={{ minimal: true, position: 'bottom' }}
      scrollToActiveItem
      items={options}
      onItemSelect={(option) => onChange(option)}
      itemListPredicate={filterTitles}
      filterable={!disableSearch}
      itemRenderer={OptionRenderer}
    >
      <Button {...buttonProps} text={options.find(({ value: val }) => value === val)?.display} />
    </TimeSelect>
  )
}

function OptionRenderer(item: timeOption, { handleClick, modifiers, query }: ItemRendererProps) {
  return (
    <MenuItem
      key={item.value}
      active={modifiers.active}
      disabled={modifiers.disabled}
      onClick={handleClick}
      text={
        <div className="flex items-center">
          <HighlightedText text={item.display} query={query} />
        </div>
      }
    />
  )
}

const filterTitles: ItemListPredicate<timeOption> = (query, moments) => {
  return query ? fuzzy.filter(moments, query, { key: 'display' }) : moments
}
